<template>
    <div class="env-pill-root" @click.stop="showHint = true">
        <!-- visibility:hidden (ne prazdny obsah) - text musi zabirat misto,
             aby tahle vrstva mela stejnou vysku jako vrstva s viditelnym
             textem, jinak box-shadow prsten pokryva pilulku nerovnomerne. -->
        <div
            class="pa-3 env-pill-layer"
            :style="'opacity: 0.4;' + washStyle"
        >
            <v-row class="pa-0 ma-0" style="visibility: hidden;">
                <v-col class="pa-0 ma-0 text-center env-pill-side-col">
                    {{ displayName }}
                </v-col>
                <div class="pa-0 ma-0 env-pill-round-placeholder" />
                <v-col class="pa-0 ma-0 env-pill-side-col">
                    <span class="ml-1">{{ displayBonusText }}</span>
                </v-col>
            </v-row>
        </div>
        <div
            class="pa-3 transparent env-pill-layer"
            :class="{ 'chip-dekorator-dark-small': !textColorFlag ,'chip-dekorator-white-small' : textColorFlag, 'white--text text-no-wrap mr-2' : textColorFlag, 'black--text': !textColorFlag}"
            :style="styleBox"
            :dark="textColorFlag"
        >
            <v-row class="pa-0 ma-0">
                <v-col class="pa-0 ma-0 text-center env-pill-side-col" :style="styleText">
                    {{ displayName }}
                </v-col>
                <div class="pa-0 ma-0 env-pill-round-placeholder" />
                <v-col class="pa-0 ma-0 env-pill-side-col" :style="styleText">
                    <span class="ml-1">{{ displayBonusText }}</span>
                </v-col>
            </v-row>
        </div>
        <EnvironmentEffectsPopup
            v-if="showHint"
            :environment="environment"
            @close="showHint = false"
        />
    </div>
</template>

<script>
    import {TYPE_COLORS, TYPE_DARK_THEME} from '@/utils/typeColorEnum';
    import EnvironmentEffectsPopup from '@/components/journey/positions/battle/EnvironmentEffectsPopup';

    export default {
        name: 'EnvironmentPill',
        components: {EnvironmentEffectsPopup},
        props: {
            environment: {type: Object, default: null},
        },
        data() {
            return {
                colors: TYPE_COLORS,
                textColors: TYPE_DARK_THEME,
                showHint: false,
            }
        },
        computed: {
            // FightReport.vue posila i null environment (zadny special) -
            // musi byt null-safe; CombatantSlot.vue si null vubec neposila.
            textColorFlag() {
                return this.environment ? this.textColors[this.environment.type.id] : false;
            },
            displayName() {
                return this.environment ? this.environment.name : '';
            },
            displayBonusText() {
                if (!this.environment) return '';
                return this.$t('journey.environmentPill.bonusPrefix') + (this.environment.bonus > 0 ? '+' : '') + this.environment.bonus;
            },
            styleBox() {
                if (!this.environment) return '';
                const rule = this.environment.rule;
                switch (rule) {
                    case 1:
                        return ' background-color: ' + this.colors[this.environment.type.id] + ';';
                    case 2:
                        return ' box-shadow: inset 0px 0px 3px 3px ' + this.colors[this.environment.type.id] + ' !important;';
                }
                return '';
            },
            // Obe vrstvy jsou DOM-presne na stejne pozici - dvojity box-shadow
            // prsten (dimmed wash + plny vrchni) je zamerny mekky "glow", ne
            // nezarovnani.
            washStyle() {
                return this.styleBox;
            },
            styleText() {
                if (!this.environment) return '';
                const rule = this.environment.rule;
                if (rule === 1 || rule === 2) {
                    // Offset musi zustat 0/0 - nenulovy offset by vytvoril
                    // viditelne posunutou "duchovitou" kopii textu misto
                    // jednotne zare za pismem.
                    return 'text-shadow: 0 0 3px ' + this.colors[this.environment.type.id] + ';';
                }
                return '';
            },
        },
    }
</script>

<style scoped>
/* .fight-report-scale-wrap (FightReport.vue) je taky position:absolute;
   top:0 na tomtez vrsku, jen vyssi - jeho padding box geometricky prekryva
   spodni cast pilulky. z-index musi byt na `.env-pill-layer` samotnem, ne
   na `.env-pill-root` (ten by zvedl i neprusvitne pozadi vrstev NAD kolecko
   kol, ktere ma zustat nad pilulkou) - EnvironmentEffectsPopup uvnitr ma
   vlastni position:fixed; z-index:2000, ktery se pocita vuci nejblizsimu
   stacking-context predkovi, takze nizky strop tady na popup nedosahne. */
.env-pill-root {
    position: relative;
}
.env-pill-layer {
    width: 100%;
    position: absolute;
    left: 0px;
    z-index: 100;
    border-radius: 4px 4px 16px 16px;
    font-size: 1.05em;
    cursor: pointer;
}
/* Fixni (ne proporcionalni) sirka placeholderu pro kolecko kol - musi
   presne odpovidat jeho prumeru (52px, viz FightReport.vue), jinak by text
   vedle mohl na uzsim viewportu zajet pod kolecko. */
.env-pill-round-placeholder {
    flex: 0 0 52px;
    width: 52px;
}
/* calc() misto Vuetify cols, at oba textove sloupce vzdy presne doplni
   zbyvajicich 100% - 52px rovnym dilem na obe strany kolecka. */
.env-pill-side-col {
    flex: 0 0 calc((100% - 52px) / 2);
    max-width: calc((100% - 52px) / 2);
}
</style>
